export default __webpack_public_path__ + "dist/media/Signed-2.0d49b510.svg";